<template>
    <div
        class="preview-overlay"
        :style="{'width': width + 'px', 'height': height + 'px'}"
    >
        <div
            v-show="displayLoader"
            class="loading-preview preview-button stopping-loader"
        >
            <div class="generation-spinner">
                <span
                    v-loading="true"
                    class="preview-spinner"
                >
                </span>
            </div>
            <p
                class="loading-title"
                :style="{'font-size': fontSize, 'margin': margin}"
            >
                Preview is stopping
            </p>
        </div>
        <div
            v-show="!displayLoader"
            :style="{'width': width + 'px', 'height': height + 'px'}"
        >
            <div
                v-if="showBanner"
                class="preview-banner"
            >

                <p
                    class="banner-descr"
                >
                   <span
                        v-if="extending"
                   >
                        Extending
                    </span>
                   <span
                        v-else-if="stoppingText"
                   >
                        Your preview will stop in a few seconds.
                    </span>
                    <span
                        v-else
                    >
                        Your preview is ending.
                    </span>
                    <el-button
                        v-if="!stoppingText"
                        class="extend-button"
                        :loading="extending"
                        @click="extendDuration()"
                    >
                        <span v-if="!extending">
                            <span
                                v-if="extendFailed"
                            >
                                Failed. Retry ?
                            </span>
                            <span
                                v-else
                            >
                                Extend Duration
                            </span>
                        </span>
                    </el-button>
                </p>
                <button
                    class="icon-close"
                    @click="closeBanner"
                >
                    <i class="ti-close" ></i>
                </button>
            </div>
            <video-player
                ref="videoPlayer"
                class="gcmcn-player"
                :style="{'width': width + 'px', 'height': height + 'px'}"
                :video-source="preview.preview_url"
                :unmuted="unmuted"
                :is-in-preview-component="true"
                @toggleSound="setUnmuted"
            ></video-player>
            <div
                class="control-overlay"
                :class="{'show-control': mouseIsOver}"
                @mouseover="mouseOver()"
                @mouseleave="mouseNotOver()"
            >
                <div
                    class="overlay-button-container"
                >
                    <button
                        class="action-button video-player-button"
                        :class="{'show-control': mouseIsOver}"
                        @click="stopPreview()"
                    >
                        <img
                        class="stop-icon"
                            src="/static/icon/square.png"
                        >
                    </button>
                    <button
                        class="action-button video-player-button"
                        :class="{'show-control': mouseIsOver}"
                        @click="toggleSound"
                    >
                        <img
                            v-if="unmuted"
                            src="/static/icon/volume-high-dark.png"
                        >
                        <img
                            v-else
                            src="/static/icon/volume-slash-dark.png"
                        >
                    </button>
                </div>
                <div
                    class="progress-bar-container"
                >
                    <button
                        class="stop-button"
                        @click="stopPreview()"
                    >
                        <img src="/static/icon/stop.png">
                    </button>
                    <div class="progess-bar">
                        <div
                            class="blue-linear"
                            :style="{'width': `${widthProgress}%` }"
                        ></div>
                    </div>
                    <button
                        class="sound-button"
                        @click="toggleSound"
                    >
                        <img
                            v-if="unmuted"
                            src="/static/icon/volume-high.png"
                        >
                        <img
                            v-else
                            src="/static/icon/volume-slash.png"
                        >
                    </button>
                    <p class="time">-{{remainingTime}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {VideoPlayer} from 'gcmcn-common';
    export default {
        components: {
            VideoPlayer,
        },
        props:{
            width: {
                default: 500,
                type: Number,
                required: false,
            },
            height: {
                default: 300,
                type: Number,
                required: false,
            },
            generatedPreview:{
                type:Object,
            },
            extendedPreview:{
                type:Object,
                default: null,
            },
            channel:{
                type: Object,
                default: null,
            },
            configuration:{
                type: Object,
                default: null,
            },
        },
        data(){
            return{
                unmuted: false,
                mouseIsOver: false,
                displayLoader: false,
                showBanner: false,
                bannerHasBeenClose: false,
                seconds: 0,
                fetchInterval: null,
                handlerCountDown: null,
                // countDownDuration: 0,
                extending: false,
                extendFailed: false,
                previewStopping: false,
                stoppingText: false,
            }
        },
        computed:{
            remainingTime(){
                return this.formatSeconds(this.seconds);
            },
            widthProgress(){
                // valeur entre 0 et 100
                // 0 si this.seconds = countDownDuration
                // 100 si this.seconds = 0
                return (100 - 100 * this.seconds / this.countDownDuration);
            },
            preview(){
                if(this.extendedPreview){
                    return this.extendedPreview
                }
                return this.generatedPreview
            },
            countDownDuration(){
                return this.getTimeDeltaInSeconds(new Date(this.preview.end_date));
            },
            // dynamic style based on component width
            fontSize(){
                return `${this.width/20}px`
            },
            margin(){
                return `${this.width/50}px`
            }
        },
        watch:{
            seconds: function (newVal){
                //replace 30 by time when banner should display
                if(newVal === 0 && !this.extending){
                    this.bannerHasBeenClose = false;
                    this.showBanner = true;
                    this.stoppingText = true;
                }else if(newVal < 30 && !this.bannerHasBeenClose){
                    this.stoppingText = false;
                    this.showBanner = true;
                }else {
                    this.showBanner = false;
                }
            },
            previewStopping: function(newVal){
                if(newVal === true){
                    this.displayLoader = true;
                    this.watchModelStatus(this.preview, 'COMPLETED', 'FAILED_TO_STOP').then(()=>{
                        this.$emit('previewOver')
                    }).catch(()=>{
                        console.error('Preview failed to stop')
                        this.displayLoader = false;
                    })
                }
            }
        },
        mounted(){
                if(this.preview.status === 'STOPPING'){
                    this.previewStopping = true
                }
                // this.countDownDuration = this.getTimeDeltaInSeconds(new Date(this.preview.end_date));
                this.enableCountDown();

                this.watchModelStatus(this.preview, 'STOPPING').then(()=>{
                    this.previewStopping = true;
                })
        },
        beforeDestroy(){
            this.disableCountDown();
        },
        methods:{
            getTimeDeltaInSeconds(endDatetime, startDatetime=null){
                if(startDatetime === null || startDatetime === undefined){
                    startDatetime = Date.now();
                }
                return Math.max(Math.floor((endDatetime - startDatetime) / 1000), 0);
            },
            enableCountDown(){
                this.updateRemainingSeconds();
                this.handlerCountDown = setTimeout(() => {
                    this.enableCountDown();
                }, 500);
            },
            updateRemainingSeconds(){
                this.seconds = this.getTimeDeltaInSeconds(new Date(this.preview.end_date));
            },
            disableCountDown(){
                clearTimeout(this.handlerCountDown);
            },
            formatSeconds(timeInSeconds){
                let minutes = Math.floor(timeInSeconds / 60);
                let seconds = timeInSeconds - minutes * 60;
                return `${minutes<10?'0':''}${minutes}:${seconds<10?'0':''}${seconds}`;
            },
            mouseOver(){
                this.mouseIsOver = true;
            },
            mouseNotOver(){
                this.mouseIsOver = false;
            },
            toggleSound(){
                this.$refs.videoPlayer.switchVolumeState()
            },
            setUnmuted() {
                this.unmuted = !this.unmuted;
            },
            closeBanner(){
                this.showBanner = false;
                this.bannerHasBeenClose = true;
            },
            stopPreview(preview){
                let context = {
                    action: 'STOP',
                    preview_uid: this.preview.uid,
                };
                let scopes = {'X-Entity-Uid': this.preview.scopes.entity_uid}
                this.displayLoader = true;
                this.createAndWatchRequest(
                    context,
                    'previewModificationRequest',
                    this.$store.state.api.meta.listModels.previewModificationRequest.url,
                    scopes
                ).then((response)=>{
                    this.watchModelStatus(response.preview, 'COMPLETED').then(()=>{
                        this.$emit('previewStopped')
                    })
                }).catch(()=>{

                })
            },
            extendDuration(){
                let context = {
                    action: 'EXTEND',
                    preview_uid: this.preview.uid,
                };
                let scopes = {'X-Entity-Uid': this.preview.scopes.entity_uid}
                this.extendFailed = false;
                this.extending = true;
                this.createAndWatchRequest(
                    context,
                    'previewModificationRequest',
                    this.$store.state.api.meta.listModels.previewModificationRequest.url,
                    scopes
                ).then((response)=>{
                    this.$emit('setPreview', response.preview)
                    this.extending = false;
                }).catch((response)=>{
                    this.extending = false;
                    this.extendFailed = true;
                })
            },
            async createAndWatchRequest(context, requestModelName, requestModelUrl, requestScopes){
                return this.$store.dispatch('createItem',{
                    item: context,
                    model: requestModelName,
                    url:  requestModelUrl,
                    scopes: requestScopes,
                }).then((response)=>{
                    return new Promise((resolve, reject) => {
                        let request = response;
                        let interval = setInterval(async ()=>{
                            if(request.status === 'COMPLETED'){
                                resolve(request);
                                clearInterval(interval);
                            } else if(request.status === 'FAILED'){
                                reject(request.verbose_status);
                                clearInterval(interval);
                            }
                            this.$store.dispatch('remoteGet', { url : request.url })
                            .then(response =>{
                                request = response.data;
                            });
                        }, 3000);
                    });
                });
            },
            async watchModelStatus(itemToWatch, successStatus, failedStatus = null){
                return new Promise((resolve, reject) => {
                    let item = itemToWatch;
                    let interval = setInterval(async ()=>{
                        if(item.status === successStatus){
                            resolve(item);
                            clearInterval(interval);
                        }
                        if(failedStatus !== null && item.status === failedStatus){
                            reject();
                            clearInterval(interval);
                        }
                        this.$store.dispatch('remoteGet', { url : itemToWatch.url })
                        .then(response =>{
                            item = response.data;
                        });
                    }, 3000);
                });
            }
        }
    };
</script>
<style>
    .preview-overlay{
        position: relative;
    }
    .preview-banner{
        position: absolute;
        top: 0;
        z-index: 99;
        width: 100%;
        background-color: #409EFF;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0.5rem;

    }
    .banner-descr{
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 700;
        font-size: 10px;
        line-height: 12px;
        color: white;
        margin: 0;
    }
    .icon-close{
        color: #ffffff;
        border: none;
        background-color: transparent;
    }
    .progress-bar-container{
        position: absolute;
        bottom: 0;
        display: flex;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        background-color: rgba(33, 33, 33, 0.75);
        height:32px;
        padding: 0.5rem;
    }
    .progess-bar{
        height: 3px;
        border-radius: 2px;
        width: 60%;
        background-color: #DFDFDF;
    }
    .blue-linear{
        position: relative;
        border-radius: 2px;
        width: 60%;
        background-color: #3F9FEE;
        height: 100%;
    }

    .blue-linear::after{
        content: '';
        width: 12px;
        height: 12px;
        background-color: #3F9FEE;
        border-radius: 50%;
        display: inline-block;
        position: absolute;
            top: -4px;
            right: -4px;
    }
    .stop-button, .sound-button{
        color: #ffffff;
        border: none;
        background-color: transparent;
    }
    .time{
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 140%;
        margin: 0;
    }
    .control-overlay{
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translate(-50%);
        width: 100%;
        height: 100%;
        opacity: 0;
        transition: opacity  0.5s ease-out;
    }
    .overlay-button-container{
        display: flex;
        justify-content: center;
        position: absolute;
        bottom: 50%;
        left: 50%;
        transform: translate(-50%, 50%);
    }
    .action-button{
        height: 40px;
        width: 40px;
        border-radius: 50%;
        border: none;
        background-color: #FFFFFF;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 0.5rem;
    }
    .video-player-button {
        opacity: 0;
    }
    .extend-button{
        border: none;
        background-color: transparent;
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 700;
        font-size: 10px;
        line-height: 12px;
        color: white;
        text-decoration: underline;
        padding: 0;
    }
    .extend-button:hover{
        border: none;
        background-color: transparent;
        color: white;
    }
    .extend-button.el-button.is-loading{
        font-size: 13px;
        margin-left: 1rem;
    }
    .extend-button.el-button.is-loading::before{
        background-color: transparent;
    }
    .show-control{
        opacity: 1 !important;
        transition: opacity  0.5s ease-out;
    }
    .stop-icon{
        width: 15px;
        height: 15px;
    }
</style>



// WEBPACK FOOTER //
// src/components/ChannelAndConfigurationPreview/video-preview.vue